<div class="change-password-container">
  <div class="change-password-content">
    <div class="card-white rounded-lg p-xl">
      <div class="header-section">
        <button mat-icon-button (click)="onCancel()" class="back-button">
          <mat-icon svgIcon="arrow_back"></mat-icon>
        </button>
        <h1>Change Password</h1>
      </div>

      <p class="description">
        Enter your current password and choose a new password. Your new password must be at least 8 characters long and contain at least one letter and one number.
      </p>

      <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" class="change-password-form">
        <div class="form-field">
          <label for="currentPassword">Current Password</label>
          <mat-form-field appearance="outline" class="form-field-standard">
            <input matInput 
                   id="currentPassword"
                   formControlName="currentPassword" 
                   [type]="hideCurrentPassword ? 'password' : 'text'"
                   placeholder="Enter your current password"
                   autocomplete="current-password">
            <button mat-icon-button 
                    matSuffix 
                    type="button"
                    (click)="toggleCurrentPasswordVisibility()"
                    class="password-toggle">
              <mat-icon [svgIcon]="hideCurrentPassword ? 'visibility_off' : 'visibility'"></mat-icon>
            </button>
          </mat-form-field>
          <div class="error-message" *ngIf="changePasswordForm.get('currentPassword')?.invalid && changePasswordForm.get('currentPassword')?.touched">
            Current password is required
          </div>
        </div>

        <div class="form-field">
          <label for="newPassword">New Password</label>
          <mat-form-field appearance="outline" class="form-field-standard">
            <input matInput 
                   id="newPassword"
                   formControlName="newPassword" 
                   [type]="hideNewPassword ? 'password' : 'text'"
                   placeholder="Enter new password"
                   autocomplete="new-password">
            <button mat-icon-button 
                    matSuffix 
                    type="button"
                    (click)="toggleNewPasswordVisibility()"
                    class="password-toggle">
              <mat-icon [svgIcon]="hideNewPassword ? 'visibility_off' : 'visibility'"></mat-icon>
            </button>
          </mat-form-field>
          <div class="error-message" *ngIf="changePasswordForm.get('newPassword')?.invalid && changePasswordForm.get('newPassword')?.touched">
            <span *ngIf="changePasswordForm.get('newPassword')?.errors?.['required']">New password is required</span>
            <span *ngIf="changePasswordForm.get('newPassword')?.errors?.['minlength']">Password must be at least 8 characters</span>
            <span *ngIf="changePasswordForm.get('newPassword')?.errors?.['passwordComplexity']">Password must contain at least one letter and one number</span>
          </div>
        </div>

        <div class="form-field">
          <label for="confirmPassword">Confirm New Password</label>
          <mat-form-field appearance="outline" class="form-field-standard">
            <input matInput 
                   id="confirmPassword"
                   formControlName="confirmPassword" 
                   [type]="hideConfirmPassword ? 'password' : 'text'"
                   placeholder="Confirm new password"
                   autocomplete="new-password">
            <button mat-icon-button 
                    matSuffix 
                    type="button"
                    (click)="toggleConfirmPasswordVisibility()"
                    class="password-toggle">
              <mat-icon [svgIcon]="hideConfirmPassword ? 'visibility_off' : 'visibility'"></mat-icon>
            </button>
          </mat-form-field>
          <div class="error-message" *ngIf="changePasswordForm.get('confirmPassword')?.invalid && changePasswordForm.get('confirmPassword')?.touched">
            Please confirm your new password
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" 
                  mat-raised-button 
                  color="primary" 
                  class="change-password-button"
                  [disabled]="!changePasswordForm.valid || isChangingPassword">
            {{isChangingPassword ? 'Changing Password...' : 'Change Password'}}
          </button>
          
          <button type="button" 
                  mat-button 
                  (click)="onCancel()"
                  class="cancel-button">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
